// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FlowBuilder Bottom Sheet + Sidebar Layout - CSS com suporte a tema */

/* Layout principal - sem scroll desnecessário */
.flow-builder-root {
  height: 100vh !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

.flow-builder-content {
  flex: 1 1 !important;
  display: flex !important;
  overflow: hidden !important;
}

/* Sidebar colapsável - DESKTOP ONLY - adaptado para tema */
.flow-builder-sidebar {
  transition: width 0.3s ease !important;
  background: var(--background-paper) !important;
  border-right: 1px solid var(--divider) !important;
  overflow: hidden !important;
  flex-shrink: 0 !important;
}

.flow-builder-sidebar-content {
  overflow-y: auto !important;
  height: 100% !important;
}

/* Esconder sidebar em mobile */
@media (max-width: 768px) {
  .flow-builder-sidebar {
    display: none !important;
  }
}

/* Flow container - ocupa espaço restante */
.flow-builder-flow-container {
  flex: 1 1 !important;
  position: relative !important;
  overflow: hidden !important;
  background: var(--background-default) !important;
}

/* Bottom Sheet - MOBILE ONLY - adaptado para tema */
.flow-builder-bottom-sheet {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: var(--background-paper) !important;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
  box-shadow: var(--shadow-8) !important;
  border: 1px solid var(--divider) !important;
  z-index: 1500 !important;
  max-height: 80vh !important;
  transform: translateY(100%) !important;
  transition: transform 0.3s ease !important;
}

.flow-builder-bottom-sheet.open {
  transform: translateY(0) !important;
}

.flow-builder-bottom-sheet-handle {
  width: 40px !important;
  height: 4px !important;
  background: var(--divider) !important;
  border-radius: 2px !important;
  margin: 8px auto !important;
  cursor: pointer !important;
}

.flow-builder-bottom-sheet-content {
  padding: 16px !important;
  overflow-y: auto !important;
  max-height: calc(80vh - 60px) !important;
  background: var(--background-paper) !important;
}

/* Esconder bottom sheet em desktop */
@media (min-width: 769px) {
  .flow-builder-bottom-sheet {
    display: none !important;
  }
}

/* FAB Buttons - adaptado para tema */
.flow-builder-fab-save {
  position: fixed !important;
  bottom: 16px !important;
  right: 16px !important;
  z-index: 1400 !important;
  background-color: var(--primary-main) !important;
  color: var(--primary-contrast-text) !important;
  box-shadow: var(--shadow-6) !important;
  transition: all 0.3s ease !important;
}

.flow-builder-fab-save:hover {
  transform: scale(1.1) !important;
  background-color: var(--primary-dark) !important;
  box-shadow: var(--shadow-12) !important;
}

.flow-builder-fab-add {
  position: fixed !important;
  bottom: 16px !important;
  left: 16px !important;
  z-index: 1400 !important;
  background-color: var(--secondary-main) !important;
  color: var(--secondary-contrast-text) !important;
  box-shadow: var(--shadow-6) !important;
}

.flow-builder-fab-add:hover {
  background-color: var(--secondary-dark) !important;
}

/* Ajustar FAB em mobile quando bottom sheet está aberto */
@media (max-width: 768px) {
  .flow-builder-fab-save {
    bottom: 80px !important;
  }
}

/* Esconder FAB de adicionar em desktop */
@media (min-width: 769px) {
  .flow-builder-fab-add {
    display: none !important;
  }
}

/* Quick Actions - DESKTOP ONLY - adaptado para tema */
.flow-builder-quick-actions {
  position: fixed !important;
  top: 80px !important;
  right: 16px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  z-index: 1200 !important;
}

.flow-builder-quick-action-btn {
  background: var(--background-paper) !important;
  backdrop-filter: blur(10px) !important;
  box-shadow: var(--shadow-3) !important;
  border: 1px solid var(--divider) !important;
  color: var(--text-primary) !important;
  transition: all 0.2s ease !important;
  width: 48px !important;
  height: 48px !important;
}

.flow-builder-quick-action-btn:hover {
  background: var(--action-hover) !important;
  transform: scale(1.05) !important;
  box-shadow: var(--shadow-6) !important;
  color: var(--primary-main) !important;
}

/* Esconder quick actions em mobile */
@media (max-width: 768px) {
  .flow-builder-quick-actions {
    display: none !important;
  }
}

/* Mobile Controls - adaptado para tema */
.flow-builder-mobile-controls {
  position: fixed !important;
  bottom: 80px !important;
  left: 16px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  z-index: 1300 !important;
}

.flow-builder-control-btn {
  background: var(--background-paper) !important;
  backdrop-filter: blur(10px) !important;
  box-shadow: var(--shadow-3) !important;
  border: 1px solid var(--divider) !important;
  color: var(--text-primary) !important;
  width: 48px !important;
  height: 48px !important;
  transition: all 0.2s ease !important;
}

.flow-builder-control-btn:hover {
  background: var(--action-hover) !important;
  transform: scale(1.05) !important;
}

/* Esconder mobile controls em desktop */
@media (min-width: 769px) {
  .flow-builder-mobile-controls {
    display: none !important;
  }
}

/* React Flow Customizations - adaptado para tema */
.react-flow__renderer {
  touch-action: manipulation !important;
}

.react-flow__controls {
  display: none !important; /* Usar nossos controles customizados */
}

.react-flow__minimap {
  bottom: 16px !important;
  right: 80px !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  background: var(--background-paper) !important;
  border: 1px solid var(--divider) !important;
}

/* Esconder minimap em mobile */
@media (max-width: 768px) {
  .react-flow__minimap {
    display: none !important;
  }
}

.react-flow__attribution {
  display: none !important;
}

/* Node styles para mobile - adaptado para tema */
@media (max-width: 768px) {
  .react-flow__node {
    min-width: 160px !important;
    min-height: 60px !important;
    font-size: 14px !important;
    background: var(--background-paper) !important;
    border: 1px solid var(--divider) !important;
    color: var(--text-primary) !important;
  }

  .react-flow__handle {
    width: 16px !important;
    height: 16px !important;
    border-width: 3px !important;
    background: var(--primary-main) !important;
    border-color: var(--primary-dark) !important;
  }

  .react-flow__edge-path {
    stroke-width: 8px !important;
    stroke: var(--primary-main) !important;
  }
}

/* Node styles para tablet - adaptado para tema */
@media (min-width: 769px) and (max-width: 1024px) {
  .react-flow__node {
    min-width: 150px !important;
    min-height: 55px !important;
    font-size: 13px !important;
    background: var(--background-paper) !important;
    border: 1px solid var(--divider) !important;
    color: var(--text-primary) !important;
  }

  .react-flow__handle {
    width: 14px !important;
    height: 14px !important;
    background: var(--primary-main) !important;
    border-color: var(--primary-dark) !important;
  }

  .react-flow__edge-path {
    stroke-width: 7px !important;
    stroke: var(--primary-main) !important;
  }
}

/* Node hover e selected states - adaptado para tema */
.react-flow__node {
  transition: all 0.2s ease !important;
  border-radius: 8px !important;
  box-shadow: var(--shadow-2) !important;
  background: var(--background-paper) !important;
  border: 1px solid var(--divider) !important;
  color: var(--text-primary) !important;
}

.react-flow__node:hover {
  box-shadow: var(--shadow-4) !important;
  border-color: var(--primary-light) !important;
}

.react-flow__node.selected {
  box-shadow: var(--shadow-6) !important;
  border: 2px solid var(--primary-main) !important;
}

/* Edge styles - adaptado para tema */
.react-flow__edge-path {
  transition: all 0.2s ease !important;
  stroke: var(--primary-main) !important;
}

.react-flow__edge:hover .react-flow__edge-path {
  stroke-width: 10px !important;
  stroke: var(--primary-dark) !important;
}

.react-flow__edge.selected .react-flow__edge-path {
  stroke: var(--primary-main) !important;
  stroke-width: 10px !important;
}

/* Sidebar node buttons - adaptado para tema */
.flow-builder-node-btn {
  justify-content: flex-start !important;
  text-transform: none !important;
  padding: 12px !important;
  margin-bottom: 4px !important;
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
  width: 100% !important;
  color: var(--text-primary) !important;
}

.flow-builder-node-btn:hover {
  background-color: var(--action-hover) !important;
  transform: translateX(4px) !important;
}

.flow-builder-collapsed-btn {
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  padding: 0 !important;
  margin: 4px 6px !important;
  justify-content: center !important;
  border-radius: 8px !important;
  color: var(--text-primary) !important;
}

.flow-builder-collapsed-btn:hover {
  background-color: var(--action-hover) !important;
}

/* Category headers - adaptado para tema */
.flow-builder-category-header {
  padding: 12px !important;
  background: var(--action-hover) !important;
  font-weight: bold !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  color: var(--text-primary) !important;
}

.flow-builder-category-header:hover {
  background: var(--action-selected) !important;
}

/* Bottom sheet grid - adaptado para tema */
.flow-builder-bottom-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 16px !important;
}

.flow-builder-category-card {
  padding: 12px !important;
  border-radius: 8px !important;
  border: 1px solid var(--divider) !important;
  background: var(--background-paper) !important;
}

.flow-builder-category-title {
  font-weight: bold !important;
  margin-bottom: 8px !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  color: var(--text-primary) !important;
}

.flow-builder-category-btn {
  width: 100% !important;
  margin-bottom: 4px !important;
  justify-content: flex-start !important;
  text-transform: none !important;
  font-size: 0.8rem !important;
  padding: 8px 12px !important;
  color: var(--text-primary) !important;
  border-color: var(--divider) !important;
}

.flow-builder-category-btn:hover {
  background-color: var(--action-hover) !important;
}

/* Loading overlay - adaptado para tema */
.flow-builder-loading {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 70vh !important;
  background: var(--background-paper) !important;
}

/* Touch improvements */
@media (pointer: coarse) {
  .MuiIconButton-root {
    padding: 12px !important;
    min-width: 48px !important;
    min-height: 48px !important;
  }
  
  .MuiButton-root {
    min-height: 48px !important;
    padding: 12px 16px !important;
  }

  .MuiListItem-button {
    min-height: 56px !important;
    padding: 12px 16px !important;
  }
}

/* Variáveis CSS para tema claro */
:root {
  --background-default: #f5f5f5;
  --background-paper: #ffffff;
  --text-primary: rgba(0, 0, 0, 0.87);
  --text-secondary: rgba(0, 0, 0, 0.6);
  --divider: rgba(0, 0, 0, 0.12);
  --primary-main: #1976d2;
  --primary-dark: #1565c0;
  --primary-light: #42a5f5;
  --primary-contrast-text: #ffffff;
  --secondary-main: #dc004e;
  --secondary-dark: #9a0036;
  --secondary-contrast-text: #ffffff;
  --action-hover: rgba(0, 0, 0, 0.04);
  --action-selected: rgba(0, 0, 0, 0.08);
  --shadow-2: 0px 1px 3px rgba(0, 0, 0, 0.12);
  --shadow-3: 0px 1px 5px rgba(0, 0, 0, 0.12);
  --shadow-4: 0px 2px 4px rgba(0, 0, 0, 0.14);
  --shadow-6: 0px 3px 5px rgba(0, 0, 0, 0.2);
  --shadow-8: 0px 5px 5px rgba(0, 0, 0, 0.2);
  --shadow-12: 0px 7px 8px rgba(0, 0, 0, 0.2);
}

/* Variáveis CSS para tema escuro */
[data-theme="dark"], 
.theme-dark,
[class*="dark"] {
  --background-default: #121212;
  --background-paper: #1e1e1e;
  --text-primary: rgba(255, 255, 255, 0.87);
  --text-secondary: rgba(255, 255, 255, 0.6);
  --divider: rgba(255, 255, 255, 0.12);
  --primary-main: #90caf9;
  --primary-dark: #42a5f5;
  --primary-light: #e3f2fd;
  --primary-contrast-text: #000000;
  --secondary-main: #f48fb1;
  --secondary-dark: #ad2d57;
  --secondary-contrast-text: #000000;
  --action-hover: rgba(255, 255, 255, 0.08);
  --action-selected: rgba(255, 255, 255, 0.12);
  --shadow-2: 0px 1px 3px rgba(0, 0, 0, 0.4);
  --shadow-3: 0px 1px 5px rgba(0, 0, 0, 0.4);
  --shadow-4: 0px 2px 4px rgba(0, 0, 0, 0.5);
  --shadow-6: 0px 3px 5px rgba(0, 0, 0, 0.6);
  --shadow-8: 0px 5px 5px rgba(0, 0, 0, 0.6);
  --shadow-12: 0px 7px 8px rgba(0, 0, 0, 0.6);
}

/* Detecção automática de tema escuro do sistema */
@media (prefers-color-scheme: dark) {
  :root {
    --background-default: #121212;
    --background-paper: #1e1e1e;
    --text-primary: rgba(255, 255, 255, 0.87);
    --text-secondary: rgba(255, 255, 255, 0.6);
    --divider: rgba(255, 255, 255, 0.12);
    --primary-main: #90caf9;
    --primary-dark: #42a5f5;
    --primary-light: #e3f2fd;
    --primary-contrast-text: #000000;
    --secondary-main: #f48fb1;
    --secondary-dark: #ad2d57;
    --secondary-contrast-text: #000000;
    --action-hover: rgba(255, 255, 255, 0.08);
    --action-selected: rgba(255, 255, 255, 0.12);
    --shadow-2: 0px 1px 3px rgba(0, 0, 0, 0.4);
    --shadow-3: 0px 1px 5px rgba(0, 0, 0, 0.4);
    --shadow-4: 0px 2px 4px rgba(0, 0, 0, 0.5);
    --shadow-6: 0px 3px 5px rgba(0, 0, 0, 0.6);
    --shadow-8: 0px 5px 5px rgba(0, 0, 0, 0.6);
    --shadow-12: 0px 7px 8px rgba(0, 0, 0, 0.6);
  }
}

/* Accessibility */
.flow-builder-node-btn:focus-visible,
.flow-builder-quick-action-btn:focus-visible,
.flow-builder-control-btn:focus-visible {
  outline: 2px solid var(--primary-main) !important;
  outline-offset: 2px !important;
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

/* Performance optimizations */
.react-flow__viewport {
  will-change: transform !important;
}

.react-flow__node {
  will-change: transform !important;
}

/* Print support */
@media print {
  .flow-builder-sidebar,
  .flow-builder-bottom-sheet,
  .flow-builder-fab-save,
  .flow-builder-fab-add,
  .flow-builder-quick-actions,
  .flow-builder-mobile-controls,
  .react-flow__minimap {
    display: none !important;
  }
}

/* Landscape mobile adjustments */
@media (max-width: 768px) and (orientation: landscape) {
  .flow-builder-bottom-sheet {
    max-height: 60vh !important;
  }
  
  .flow-builder-mobile-controls {
    bottom: 60px !important;
  }
}

/* High contrast support */
@media (prefers-contrast: high) {
  .react-flow__edge-path {
    stroke-width: 8px !important;
  }

  .react-flow__node {
    border-width: 2px !important;
  }

  .react-flow__handle {
    border-width: 3px !important;
  }
}

/* Scrollbar customization - adaptado para tema */
.flow-builder-sidebar-content::-webkit-scrollbar,
.flow-builder-bottom-sheet-content::-webkit-scrollbar {
  width: 6px !important;
}

.flow-builder-sidebar-content::-webkit-scrollbar-track,
.flow-builder-bottom-sheet-content::-webkit-scrollbar-track {
  background: transparent !important;
}

.flow-builder-sidebar-content::-webkit-scrollbar-thumb,
.flow-builder-bottom-sheet-content::-webkit-scrollbar-thumb {
  background: var(--divider) !important;
  border-radius: 3px !important;
}

.flow-builder-sidebar-content::-webkit-scrollbar-thumb:hover,
.flow-builder-bottom-sheet-content::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary) !important;
}

/* Fix para mobile - tela branca */
.flow-builder-mobile-container {
  width: 100% !important;
  height: 100% !important;
  min-height: 100vh !important;
  background: var(--background-default) !important;
}

@media (max-width: 768px) {
  .react-flow {
    width: 100% !important;
    height: 100% !important;
  }
  
  .react-flow__renderer {
    width: 100% !important;
    height: 100% !important;
  }
  
  .flow-builder-flow-container {
    width: 100% !important;
    height: 100% !important;
    min-height: calc(100vh - 64px) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/FlowBuilderConfig/mobile-styles.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE,gDAAgD;AAChD;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,oBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,iDAAiD;EACjD,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,2CAA2C;AAC3C;EACE,oBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,oDAAoD;AACpD;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,uCAAuC;EACvC,wCAAwC;EACxC,sCAAsC;EACtC,2CAA2C;EAC3C,wBAAwB;EACxB,2BAA2B;EAC3B,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qCAAqC;EACrC,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA,qCAAqC;AACrC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,gDAAgD;EAChD,8CAA8C;EAC9C,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;EAChD,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,kDAAkD;EAClD,gDAAgD;EAChD,sCAAsC;AACxC;;AAEA;EACE,kDAAkD;AACpD;;AAEA,0DAA0D;AAC1D;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,sDAAsD;AACtD;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,sCAAsC;EACtC,2CAA2C;EAC3C,qCAAqC;EACrC,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,qCAAqC;AACrC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,yCAAyC;AACzC;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,sCAAsC;EACtC,2CAA2C;EAC3C,qCAAqC;EACrC,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA,wCAAwC;AACxC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,mDAAmD;AACnD;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB,EAAE,uCAAuC;AACnE;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA,+BAA+B;AAC/B;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,8CAA8C;IAC9C,2CAA2C;IAC3C,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,0CAA0C;IAC1C,4CAA4C;EAC9C;;EAEA;IACE,4BAA4B;IAC5B,sCAAsC;EACxC;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,8CAA8C;IAC9C,2CAA2C;IAC3C,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0CAA0C;IAC1C,4CAA4C;EAC9C;;EAEA;IACE,4BAA4B;IAC5B,sCAAsC;EACxC;AACF;;AAEA,sDAAsD;AACtD;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,sCAAsC;EACtC,8CAA8C;EAC9C,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA,8CAA8C;AAC9C;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;AAClD;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,4BAA4B;EAC5B,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;EACxB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,gDAAgD;AAClD;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;AACF;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;EACzB,kCAAkC;EAClC,mCAAmC;EACnC,sCAAsC;EACtC,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,mCAAmC;AACnC;;;EAGE,6BAA6B;EAC7B,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;EAC1C,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;EACzB,kCAAkC;EAClC,yCAAyC;EACzC,4CAA4C;EAC5C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA,kDAAkD;AAClD;EACE;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,yCAAyC;IACzC,0CAA0C;IAC1C,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,gCAAgC;IAChC,yBAAyB;IACzB,yBAAyB;IACzB,kCAAkC;IAClC,yCAAyC;IACzC,4CAA4C;IAC5C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,0CAA0C;IAC1C,2CAA2C;EAC7C;AACF;;AAEA,kBAAkB;AAClB;;;EAGE,iDAAiD;EACjD,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE;IACE,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA,8BAA8B;AAC9B;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE;;;;;;;IAOE,wBAAwB;EAC1B;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,iDAAiD;AACjD;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,yCAAyC;EAC3C;AACF","sourcesContent":["/* FlowBuilder Bottom Sheet + Sidebar Layout - CSS com suporte a tema */\n\n/* Layout principal - sem scroll desnecessário */\n.flow-builder-root {\n  height: 100vh !important;\n  overflow: hidden !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.flow-builder-content {\n  flex: 1 !important;\n  display: flex !important;\n  overflow: hidden !important;\n}\n\n/* Sidebar colapsável - DESKTOP ONLY - adaptado para tema */\n.flow-builder-sidebar {\n  transition: width 0.3s ease !important;\n  background: var(--background-paper) !important;\n  border-right: 1px solid var(--divider) !important;\n  overflow: hidden !important;\n  flex-shrink: 0 !important;\n}\n\n.flow-builder-sidebar-content {\n  overflow-y: auto !important;\n  height: 100% !important;\n}\n\n/* Esconder sidebar em mobile */\n@media (max-width: 768px) {\n  .flow-builder-sidebar {\n    display: none !important;\n  }\n}\n\n/* Flow container - ocupa espaço restante */\n.flow-builder-flow-container {\n  flex: 1 !important;\n  position: relative !important;\n  overflow: hidden !important;\n  background: var(--background-default) !important;\n}\n\n/* Bottom Sheet - MOBILE ONLY - adaptado para tema */\n.flow-builder-bottom-sheet {\n  position: fixed !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  background: var(--background-paper) !important;\n  border-top-left-radius: 20px !important;\n  border-top-right-radius: 20px !important;\n  box-shadow: var(--shadow-8) !important;\n  border: 1px solid var(--divider) !important;\n  z-index: 1500 !important;\n  max-height: 80vh !important;\n  transform: translateY(100%) !important;\n  transition: transform 0.3s ease !important;\n}\n\n.flow-builder-bottom-sheet.open {\n  transform: translateY(0) !important;\n}\n\n.flow-builder-bottom-sheet-handle {\n  width: 40px !important;\n  height: 4px !important;\n  background: var(--divider) !important;\n  border-radius: 2px !important;\n  margin: 8px auto !important;\n  cursor: pointer !important;\n}\n\n.flow-builder-bottom-sheet-content {\n  padding: 16px !important;\n  overflow-y: auto !important;\n  max-height: calc(80vh - 60px) !important;\n  background: var(--background-paper) !important;\n}\n\n/* Esconder bottom sheet em desktop */\n@media (min-width: 769px) {\n  .flow-builder-bottom-sheet {\n    display: none !important;\n  }\n}\n\n/* FAB Buttons - adaptado para tema */\n.flow-builder-fab-save {\n  position: fixed !important;\n  bottom: 16px !important;\n  right: 16px !important;\n  z-index: 1400 !important;\n  background-color: var(--primary-main) !important;\n  color: var(--primary-contrast-text) !important;\n  box-shadow: var(--shadow-6) !important;\n  transition: all 0.3s ease !important;\n}\n\n.flow-builder-fab-save:hover {\n  transform: scale(1.1) !important;\n  background-color: var(--primary-dark) !important;\n  box-shadow: var(--shadow-12) !important;\n}\n\n.flow-builder-fab-add {\n  position: fixed !important;\n  bottom: 16px !important;\n  left: 16px !important;\n  z-index: 1400 !important;\n  background-color: var(--secondary-main) !important;\n  color: var(--secondary-contrast-text) !important;\n  box-shadow: var(--shadow-6) !important;\n}\n\n.flow-builder-fab-add:hover {\n  background-color: var(--secondary-dark) !important;\n}\n\n/* Ajustar FAB em mobile quando bottom sheet está aberto */\n@media (max-width: 768px) {\n  .flow-builder-fab-save {\n    bottom: 80px !important;\n  }\n}\n\n/* Esconder FAB de adicionar em desktop */\n@media (min-width: 769px) {\n  .flow-builder-fab-add {\n    display: none !important;\n  }\n}\n\n/* Quick Actions - DESKTOP ONLY - adaptado para tema */\n.flow-builder-quick-actions {\n  position: fixed !important;\n  top: 80px !important;\n  right: 16px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 8px !important;\n  z-index: 1200 !important;\n}\n\n.flow-builder-quick-action-btn {\n  background: var(--background-paper) !important;\n  backdrop-filter: blur(10px) !important;\n  box-shadow: var(--shadow-3) !important;\n  border: 1px solid var(--divider) !important;\n  color: var(--text-primary) !important;\n  transition: all 0.2s ease !important;\n  width: 48px !important;\n  height: 48px !important;\n}\n\n.flow-builder-quick-action-btn:hover {\n  background: var(--action-hover) !important;\n  transform: scale(1.05) !important;\n  box-shadow: var(--shadow-6) !important;\n  color: var(--primary-main) !important;\n}\n\n/* Esconder quick actions em mobile */\n@media (max-width: 768px) {\n  .flow-builder-quick-actions {\n    display: none !important;\n  }\n}\n\n/* Mobile Controls - adaptado para tema */\n.flow-builder-mobile-controls {\n  position: fixed !important;\n  bottom: 80px !important;\n  left: 16px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 8px !important;\n  z-index: 1300 !important;\n}\n\n.flow-builder-control-btn {\n  background: var(--background-paper) !important;\n  backdrop-filter: blur(10px) !important;\n  box-shadow: var(--shadow-3) !important;\n  border: 1px solid var(--divider) !important;\n  color: var(--text-primary) !important;\n  width: 48px !important;\n  height: 48px !important;\n  transition: all 0.2s ease !important;\n}\n\n.flow-builder-control-btn:hover {\n  background: var(--action-hover) !important;\n  transform: scale(1.05) !important;\n}\n\n/* Esconder mobile controls em desktop */\n@media (min-width: 769px) {\n  .flow-builder-mobile-controls {\n    display: none !important;\n  }\n}\n\n/* React Flow Customizations - adaptado para tema */\n.react-flow__renderer {\n  touch-action: manipulation !important;\n}\n\n.react-flow__controls {\n  display: none !important; /* Usar nossos controles customizados */\n}\n\n.react-flow__minimap {\n  bottom: 16px !important;\n  right: 80px !important;\n  border-radius: 8px !important;\n  overflow: hidden !important;\n  background: var(--background-paper) !important;\n  border: 1px solid var(--divider) !important;\n}\n\n/* Esconder minimap em mobile */\n@media (max-width: 768px) {\n  .react-flow__minimap {\n    display: none !important;\n  }\n}\n\n.react-flow__attribution {\n  display: none !important;\n}\n\n/* Node styles para mobile - adaptado para tema */\n@media (max-width: 768px) {\n  .react-flow__node {\n    min-width: 160px !important;\n    min-height: 60px !important;\n    font-size: 14px !important;\n    background: var(--background-paper) !important;\n    border: 1px solid var(--divider) !important;\n    color: var(--text-primary) !important;\n  }\n\n  .react-flow__handle {\n    width: 16px !important;\n    height: 16px !important;\n    border-width: 3px !important;\n    background: var(--primary-main) !important;\n    border-color: var(--primary-dark) !important;\n  }\n\n  .react-flow__edge-path {\n    stroke-width: 8px !important;\n    stroke: var(--primary-main) !important;\n  }\n}\n\n/* Node styles para tablet - adaptado para tema */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .react-flow__node {\n    min-width: 150px !important;\n    min-height: 55px !important;\n    font-size: 13px !important;\n    background: var(--background-paper) !important;\n    border: 1px solid var(--divider) !important;\n    color: var(--text-primary) !important;\n  }\n\n  .react-flow__handle {\n    width: 14px !important;\n    height: 14px !important;\n    background: var(--primary-main) !important;\n    border-color: var(--primary-dark) !important;\n  }\n\n  .react-flow__edge-path {\n    stroke-width: 7px !important;\n    stroke: var(--primary-main) !important;\n  }\n}\n\n/* Node hover e selected states - adaptado para tema */\n.react-flow__node {\n  transition: all 0.2s ease !important;\n  border-radius: 8px !important;\n  box-shadow: var(--shadow-2) !important;\n  background: var(--background-paper) !important;\n  border: 1px solid var(--divider) !important;\n  color: var(--text-primary) !important;\n}\n\n.react-flow__node:hover {\n  box-shadow: var(--shadow-4) !important;\n  border-color: var(--primary-light) !important;\n}\n\n.react-flow__node.selected {\n  box-shadow: var(--shadow-6) !important;\n  border: 2px solid var(--primary-main) !important;\n}\n\n/* Edge styles - adaptado para tema */\n.react-flow__edge-path {\n  transition: all 0.2s ease !important;\n  stroke: var(--primary-main) !important;\n}\n\n.react-flow__edge:hover .react-flow__edge-path {\n  stroke-width: 10px !important;\n  stroke: var(--primary-dark) !important;\n}\n\n.react-flow__edge.selected .react-flow__edge-path {\n  stroke: var(--primary-main) !important;\n  stroke-width: 10px !important;\n}\n\n/* Sidebar node buttons - adaptado para tema */\n.flow-builder-node-btn {\n  justify-content: flex-start !important;\n  text-transform: none !important;\n  padding: 12px !important;\n  margin-bottom: 4px !important;\n  border-radius: 8px !important;\n  transition: all 0.2s ease !important;\n  width: 100% !important;\n  color: var(--text-primary) !important;\n}\n\n.flow-builder-node-btn:hover {\n  background-color: var(--action-hover) !important;\n  transform: translateX(4px) !important;\n}\n\n.flow-builder-collapsed-btn {\n  width: 48px !important;\n  height: 48px !important;\n  min-width: 48px !important;\n  padding: 0 !important;\n  margin: 4px 6px !important;\n  justify-content: center !important;\n  border-radius: 8px !important;\n  color: var(--text-primary) !important;\n}\n\n.flow-builder-collapsed-btn:hover {\n  background-color: var(--action-hover) !important;\n}\n\n/* Category headers - adaptado para tema */\n.flow-builder-category-header {\n  padding: 12px !important;\n  background: var(--action-hover) !important;\n  font-weight: bold !important;\n  cursor: pointer !important;\n  user-select: none !important;\n  color: var(--text-primary) !important;\n}\n\n.flow-builder-category-header:hover {\n  background: var(--action-selected) !important;\n}\n\n/* Bottom sheet grid - adaptado para tema */\n.flow-builder-bottom-grid {\n  display: grid !important;\n  grid-template-columns: 1fr 1fr !important;\n  gap: 16px !important;\n}\n\n.flow-builder-category-card {\n  padding: 12px !important;\n  border-radius: 8px !important;\n  border: 1px solid var(--divider) !important;\n  background: var(--background-paper) !important;\n}\n\n.flow-builder-category-title {\n  font-weight: bold !important;\n  margin-bottom: 8px !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  color: var(--text-primary) !important;\n}\n\n.flow-builder-category-btn {\n  width: 100% !important;\n  margin-bottom: 4px !important;\n  justify-content: flex-start !important;\n  text-transform: none !important;\n  font-size: 0.8rem !important;\n  padding: 8px 12px !important;\n  color: var(--text-primary) !important;\n  border-color: var(--divider) !important;\n}\n\n.flow-builder-category-btn:hover {\n  background-color: var(--action-hover) !important;\n}\n\n/* Loading overlay - adaptado para tema */\n.flow-builder-loading {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  height: 70vh !important;\n  background: var(--background-paper) !important;\n}\n\n/* Touch improvements */\n@media (pointer: coarse) {\n  .MuiIconButton-root {\n    padding: 12px !important;\n    min-width: 48px !important;\n    min-height: 48px !important;\n  }\n  \n  .MuiButton-root {\n    min-height: 48px !important;\n    padding: 12px 16px !important;\n  }\n\n  .MuiListItem-button {\n    min-height: 56px !important;\n    padding: 12px 16px !important;\n  }\n}\n\n/* Variáveis CSS para tema claro */\n:root {\n  --background-default: #f5f5f5;\n  --background-paper: #ffffff;\n  --text-primary: rgba(0, 0, 0, 0.87);\n  --text-secondary: rgba(0, 0, 0, 0.6);\n  --divider: rgba(0, 0, 0, 0.12);\n  --primary-main: #1976d2;\n  --primary-dark: #1565c0;\n  --primary-light: #42a5f5;\n  --primary-contrast-text: #ffffff;\n  --secondary-main: #dc004e;\n  --secondary-dark: #9a0036;\n  --secondary-contrast-text: #ffffff;\n  --action-hover: rgba(0, 0, 0, 0.04);\n  --action-selected: rgba(0, 0, 0, 0.08);\n  --shadow-2: 0px 1px 3px rgba(0, 0, 0, 0.12);\n  --shadow-3: 0px 1px 5px rgba(0, 0, 0, 0.12);\n  --shadow-4: 0px 2px 4px rgba(0, 0, 0, 0.14);\n  --shadow-6: 0px 3px 5px rgba(0, 0, 0, 0.2);\n  --shadow-8: 0px 5px 5px rgba(0, 0, 0, 0.2);\n  --shadow-12: 0px 7px 8px rgba(0, 0, 0, 0.2);\n}\n\n/* Variáveis CSS para tema escuro */\n[data-theme=\"dark\"], \n.theme-dark,\n[class*=\"dark\"] {\n  --background-default: #121212;\n  --background-paper: #1e1e1e;\n  --text-primary: rgba(255, 255, 255, 0.87);\n  --text-secondary: rgba(255, 255, 255, 0.6);\n  --divider: rgba(255, 255, 255, 0.12);\n  --primary-main: #90caf9;\n  --primary-dark: #42a5f5;\n  --primary-light: #e3f2fd;\n  --primary-contrast-text: #000000;\n  --secondary-main: #f48fb1;\n  --secondary-dark: #ad2d57;\n  --secondary-contrast-text: #000000;\n  --action-hover: rgba(255, 255, 255, 0.08);\n  --action-selected: rgba(255, 255, 255, 0.12);\n  --shadow-2: 0px 1px 3px rgba(0, 0, 0, 0.4);\n  --shadow-3: 0px 1px 5px rgba(0, 0, 0, 0.4);\n  --shadow-4: 0px 2px 4px rgba(0, 0, 0, 0.5);\n  --shadow-6: 0px 3px 5px rgba(0, 0, 0, 0.6);\n  --shadow-8: 0px 5px 5px rgba(0, 0, 0, 0.6);\n  --shadow-12: 0px 7px 8px rgba(0, 0, 0, 0.6);\n}\n\n/* Detecção automática de tema escuro do sistema */\n@media (prefers-color-scheme: dark) {\n  :root {\n    --background-default: #121212;\n    --background-paper: #1e1e1e;\n    --text-primary: rgba(255, 255, 255, 0.87);\n    --text-secondary: rgba(255, 255, 255, 0.6);\n    --divider: rgba(255, 255, 255, 0.12);\n    --primary-main: #90caf9;\n    --primary-dark: #42a5f5;\n    --primary-light: #e3f2fd;\n    --primary-contrast-text: #000000;\n    --secondary-main: #f48fb1;\n    --secondary-dark: #ad2d57;\n    --secondary-contrast-text: #000000;\n    --action-hover: rgba(255, 255, 255, 0.08);\n    --action-selected: rgba(255, 255, 255, 0.12);\n    --shadow-2: 0px 1px 3px rgba(0, 0, 0, 0.4);\n    --shadow-3: 0px 1px 5px rgba(0, 0, 0, 0.4);\n    --shadow-4: 0px 2px 4px rgba(0, 0, 0, 0.5);\n    --shadow-6: 0px 3px 5px rgba(0, 0, 0, 0.6);\n    --shadow-8: 0px 5px 5px rgba(0, 0, 0, 0.6);\n    --shadow-12: 0px 7px 8px rgba(0, 0, 0, 0.6);\n  }\n}\n\n/* Accessibility */\n.flow-builder-node-btn:focus-visible,\n.flow-builder-quick-action-btn:focus-visible,\n.flow-builder-control-btn:focus-visible {\n  outline: 2px solid var(--primary-main) !important;\n  outline-offset: 2px !important;\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n/* Performance optimizations */\n.react-flow__viewport {\n  will-change: transform !important;\n}\n\n.react-flow__node {\n  will-change: transform !important;\n}\n\n/* Print support */\n@media print {\n  .flow-builder-sidebar,\n  .flow-builder-bottom-sheet,\n  .flow-builder-fab-save,\n  .flow-builder-fab-add,\n  .flow-builder-quick-actions,\n  .flow-builder-mobile-controls,\n  .react-flow__minimap {\n    display: none !important;\n  }\n}\n\n/* Landscape mobile adjustments */\n@media (max-width: 768px) and (orientation: landscape) {\n  .flow-builder-bottom-sheet {\n    max-height: 60vh !important;\n  }\n  \n  .flow-builder-mobile-controls {\n    bottom: 60px !important;\n  }\n}\n\n/* High contrast support */\n@media (prefers-contrast: high) {\n  .react-flow__edge-path {\n    stroke-width: 8px !important;\n  }\n\n  .react-flow__node {\n    border-width: 2px !important;\n  }\n\n  .react-flow__handle {\n    border-width: 3px !important;\n  }\n}\n\n/* Scrollbar customization - adaptado para tema */\n.flow-builder-sidebar-content::-webkit-scrollbar,\n.flow-builder-bottom-sheet-content::-webkit-scrollbar {\n  width: 6px !important;\n}\n\n.flow-builder-sidebar-content::-webkit-scrollbar-track,\n.flow-builder-bottom-sheet-content::-webkit-scrollbar-track {\n  background: transparent !important;\n}\n\n.flow-builder-sidebar-content::-webkit-scrollbar-thumb,\n.flow-builder-bottom-sheet-content::-webkit-scrollbar-thumb {\n  background: var(--divider) !important;\n  border-radius: 3px !important;\n}\n\n.flow-builder-sidebar-content::-webkit-scrollbar-thumb:hover,\n.flow-builder-bottom-sheet-content::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary) !important;\n}\n\n/* Fix para mobile - tela branca */\n.flow-builder-mobile-container {\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 100vh !important;\n  background: var(--background-default) !important;\n}\n\n@media (max-width: 768px) {\n  .react-flow {\n    width: 100% !important;\n    height: 100% !important;\n  }\n  \n  .react-flow__renderer {\n    width: 100% !important;\n    height: 100% !important;\n  }\n  \n  .flow-builder-flow-container {\n    width: 100% !important;\n    height: 100% !important;\n    min-height: calc(100vh - 64px) !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
